import { useContext } from 'react'
import { SearchContext } from '../containers/contexts/search'

export const useAccountDetails = () => {
  const {
    accountDetailsState,
    accountNotesState,
    accountOwnerState,
    accountPositionsState,
    activitiesState,
    balanceState,
    correspondentState,
    tradingRestrictionsState,
    authorizedTradersState,
    investmentProfileState,
    documentsState,
    ePreferencesState,
    marginCallsState,
    marginsState,
    amountAvailableState,
    interestedPartiesState,
    securemailState,
    getAccountDetails,
    getAccountNotes,
    getBalances,
    getCorrespondent,
    getAccountOwners,
    getAccountPositions,
    getActivities,
    getMarginCalls,
    getMargins,
    getTradingRestrictions,
    getAuthorizedTraders,
    getInvestmentProfile,
    getDocuments,
    getEPreferences,
    getAmountAvailable,
    getInterestedParties,
    getSecuremailLinks,
  } = useContext(SearchContext)
  return {
    accountDetailsState,
    accountNotesState,
    accountOwnerState,
    accountPositionsState,
    activitiesState,
    balanceState,
    correspondentState,
    tradingRestrictionsState,
    authorizedTradersState,
    investmentProfileState,
    documentsState,
    ePreferencesState,
    marginCallsState,
    marginsState,
    amountAvailableState,
    interestedPartiesState,
    securemailState,
    getAccountDetails,
    getAccountNotes,
    getBalances,
    getCorrespondent,
    getAccountOwners,
    getAccountPositions,
    getActivities,
    getMarginCalls,
    getMargins,
    getTradingRestrictions,
    getAuthorizedTraders,
    getInvestmentProfile,
    getDocuments,
    getEPreferences,
    getAmountAvailable,
    getInterestedParties,
    getSecuremailLinks,
  }
}
